module.exports = __webpack_public_path__ + "static/b-obstetrico-09f9cb586f1b625c08c71827d5c482d2.jpg";